var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg044DepartureDashboard(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "70px",
    height: "60px",
    viewBox: "0 0 70 60",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "044-departure") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    x: "-6.4%",
    y: "-23.5%",
    width: "112.8%",
    height: "146.9%",
    filterUnits: "objectBoundingBox",
    id: "filter-1"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 4,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.0396941925 0",
    type: "matrix",
    in: "shadowBlurOuter1",
    result: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "JetOS-v3-/-Lightmode",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "JetOS-Light/v3/01.1-Dashboard-new",
    transform: "translate(-760.000000, -276.000000)",
    fill: "#ADF0D7",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "CONTENT",
    transform: "translate(375.000000, 184.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Number",
    transform: "translate(1.000000, 75.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: 2,
    filter: "url(#filter-1)",
    transform: "translate(381.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Content",
    transform: "translate(20.000000, 17.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "044-departure",
    transform: "translate(0.000000, 17.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.4406303,6.30591763 C31.3907527,5.16795181 28.113625,4.99548752 24.9633411,5.80714268 L20.8696736,6.86189644 L9.27119517,0.141474189 C9.03283007,0.00338704626 8.75063231,-0.0354807415 8.48439764,0.0331066432 L3.61265138,1.28839366 C3.21911617,1.38988726 2.9179261,1.71028917 2.83778415,2.11268692 C2.75764219,2.51508467 2.91272386,2.92830217 3.23676044,3.17576548 L11.2974625,9.32827073 L7.97828784,10.1834861 L3.40551058,7.44359921 C2.92260393,7.15431116 2.30012685,7.29700102 1.9880094,7.76870185 L0.178304761,10.5040408 C-0.0961097617,10.9188105 -0.0498114549,11.4703297 0.289820479,11.8324493 L5.76112193,17.6666027 C6.02465884,17.9475964 6.4180039,18.0624892 6.78923216,17.9669051 L34.2037473,10.9036151 C35.2373419,10.6372796 35.9411003,9.76948653 35.9965066,8.69291713 C36.0520535,7.61620562 35.4413186,6.67934154 34.4406303,6.30591763 L34.4406303,6.30591763 Z M33.6815359,8.83354623 L6.86833379,15.7419951 L2.40468162,10.9822082 L3.18866665,9.79712913 L7.27663882,12.2464489 C7.5175252,12.3907589 7.80523634,12.432546 8.0765848,12.3626331 L13.9492303,10.8495379 C14.3428432,10.7481415 14.6441256,10.4277301 14.7242777,10.0252813 C14.8044299,9.62283251 14.6492667,9.20957016 14.3251213,8.96216607 L6.26434891,2.80966082 L8.59155398,2.21012182 L20.1900324,8.93047301 C20.428383,9.06852696 20.7105461,9.10739344 20.9767596,9.03884055 L25.4854822,7.87721152 C28.2189532,7.17300012 31.0622524,7.32258287 33.7084656,8.3099711 C33.8330595,8.35637373 33.8925439,8.44789989 33.8857236,8.58177822 C33.8789032,8.71558549 33.8101376,8.80036089 33.6815359,8.83354623 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.0131721,23.2941176 L1.045721,23.2941176 C0.468212516,23.2941176 0,23.7681967 0,24.3529412 C0,24.9376856 0.468212516,25.4117647 1.045721,25.4117647 L18.0131025,25.4117647 C18.590611,25.4117647 19.0588235,24.9376856 19.0588235,24.3529412 C19.0588235,23.7681967 18.5906806,23.2941176 18.0131721,23.2941176 Z",
    id: "Path"
  }))))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg044DepartureDashboard);
export default __webpack_public_path__ + "static/media/044-departure-dashboard.c23fad76.svg";
export { ForwardRef as ReactComponent };